// messages.js

const messages = {
    '简体讯息': `***耶和华是我的力量，是我的盾牌，我心里倚靠他，就得帮助；所以我心中欢乐，我必用诗歌颂赞他！ (诗篇28:7)   
                **欢迎莅临诗歌点播网，这里有动人心弦的诗歌，提供您欣赏、学唱诗歌及录音的环境。
                *以下介绍歌曲搜寻方法: 
                  1.输入简体或繁体歌名。 
                  2.输入中文歌名字首拼音缩写，例如找歌曲'何等恩典' 可输入hded。 
                  3.输入英文歌名、原唱、编号。以上搜寻不必输入完整名称，不分大小写，直接按回车键就可查询。 
                *按YouTube影片右下角齿轮，可以设定增加显示广东话及英文歌词字幕，并可将字型放大400%。 
                *按导唱及伴奏按钮可当伴唱机切换。
                *按歌单抬头，可以切换歌单由大到小、由小到大或随机排列。 
                *右下角有按钮可切换画面文字的简体、繁体、英文转换。
                *按歌词按钮可以看到完整歌词并可复制。
                *使用录音功能请先在手机安装VV音乐APP, VV音乐不支持在电脑环境录音。
                *用Google帳號或信箱密碼登入帳號後:
                  1.可以編輯5個 '自選歌單' 並自訂按鈕名稱，將自己喜愛的歌曲勾選入歌單後，可隨時點選按鈕收聽。
                  2.可以將自己翻唱的YouTube歌曲鏈結或VV音乐歌曲链结貼到歌曲清單,按翻唱按鈕播放.
                  3.可以貼上5個YouTube播放清單。`,
    '繁體訊息': `***耶和華是我的力量，是我的盾牌，我心裡倚靠他，就得幫助；所以我心中歡樂，我必用詩歌頌贊他！ (詩篇28:7)     
                **歡迎蒞臨詩歌點播網，這裡有動人心弦的詩歌，提供您欣賞、學唱詩歌及錄音的環境。
                *以下介紹歌曲搜尋方法: 
                  1.輸入簡體或繁體歌名。 
                  2.輸入中文歌名字首拼音縮寫，例如找歌曲'何等恩典' 可輸入hded。 
                  3.輸入英文歌名、原唱、編號。以上搜尋不必輸入完整名稱，不分大小寫，直接按回車鍵就可查詢。 
                *按YouTube影片右下角齒輪，可以設定增加顯示廣東話及英文歌詞字幕，並可將字型放大400%。 
                *按導唱及伴奏按鈕可當伴唱機切換。 
                *按歌單抬頭，可以切換歌單由大到小、由小到大或隨機排列。
                *右下角有按鈕可切換畫面文字的簡體、繁體、英文轉換。
                *按歌詞按鈕可以看到完整歌詞並可複製。
                *使用錄音功能請先在手機安裝VV音樂APP, VV音樂不支援在電腦環境錄音。
                *用Google帳號或信箱密碼登入帳號後:
                  1.可以編輯5個 '自選歌單' 並自訂按鈕名稱，將自己喜愛的歌曲勾選入歌單後，可隨時點選按鈕收聽。
                  2.可以將自己翻唱的YouTube歌曲鏈結或VV音樂歌曲鏈結貼到歌曲清單,按翻唱按鈕播放.
                  3.可以貼上5個YouTube播放清單。`,
    '英文訊息': `***The Lord is my strength and my shield; my heart trusts in him, and he helps me. My heart leaps for joy, and with my song I praise him. (Psalm 28:7)
                **Welcome to Hymns Player. You can find beautiful hymns to enjoy, practice worship, and recording.
                *Methods to search for hymns:
                  1. Enter the song name in Simplified or Traditional Chinese.
                  2. Enter the first character of pinyin for the song name. For example, to search the song‘何等恩典 How Could It Be’you can enter‘hded’.
                  3. Enter the English song name, singer name, or number. For the above searches, you do not need to enter the full name; it is case-insensitive, just press the Enter key to search.
                *By clicking the gear icon in the bottom right corner of YouTube video, you can display lyrics in Cantonese and English, and enlarge the font size by 400%.
                *By clicking the 'ORIG Voice' and 'Accompany' buttons, you can switch to karaoke mode.
                *By clicking the playlist header, you can switch the playlist arrangement from largest to smallest, smallest to largest, or random.
                *The button in the bottom right corner switches language between Simplified Chinese, Traditional Chinese, and English.
                *Click the Lyrics button to view the full lyrics and copy them.
                *To use the recording function, please install the VV Music APP on your mobile phone first. VV Music does not support recording in a computer environment.
                *After logging in with your Google account or email password:
                  1.You can edit up to 5 custom playlists and name the buttons. Add your favorite songs to the playlists and listen to them at any time by clicking the button.
                  2.You can paste the link to a YouTube song or a VV Music song you've covered into your playlist and press the cover button to play it.
                  3.You can paste up to 5 YouTube playlists.`
  };
  
  export default messages;
  